/* /auth/login — nơi gateway trả về sau khi đăng nhập Google: ghi nhận rồi quay lại trang cũ. */
import { useEffect } from "react"
import { LoadingState, Page, usePageTitle } from "@/components/page"
import { api, trackBehavior } from "@/lib/api"

export default function AuthReturnPage() {
  usePageTitle("Đăng nhập thành công", "Simba đang đưa con trở lại nội dung vừa xem.")
  useEffect(() => {
    const target = new URLSearchParams(location.search).get("returnTo") || "/"
    api("/api/session")
      .then(async ({ user }) => {
        if (user) await trackBehavior("login", "/auth/login").catch(() => {})
        location.replace(target.startsWith(location.origin) ? target : "/")
      })
      .catch(() => location.replace("/"))
  }, [])
  return (
    <Page className="max-w-xl">
      <div className="flex flex-col items-center gap-3 py-10 text-center">
        <img src="/brand/sutucon/mascots-2d/lion-celebrate.svg" alt="" className="size-28" />
        <h1 className="font-heading text-2xl font-bold text-ink">Đăng nhập thành công</h1>
        <p className="text-muted-foreground">Simba đang đưa con trở lại nội dung vừa xem…</p>
        <LoadingState label="Đang chuyển trang…" />
      </div>
    </Page>
  )
}
